import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/first';

import { User } from '../models/user';
import { BaseService } from './base.service';
import { LibraryHelper } from '../@core/helpers/library.helper';
import { environment } from '../../environments/environment';
import { ClientService } from 'app/@core/services/client.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthService {

  private _client;

  constructor(
    public http: HttpClient,
    public router: Router
  ) {
    this._client = new ClientService(http);
  }

  login(user: User): any {
    const body = {
      //client_id: 'asta',
      //client_secret: '123456',
      //grant_type: 'password',
      email: user.username,
      password: user.password
    };
    return this.http.post(environment.baseUrl + '/api/oauth/access_token', body);
  }

  register(user: User, clientId: number): Observable<any> {
    const body = {
      client_id: clientId,
      user
    };
    const url = environment.baseUrl + '/api/v2/client/register';
    return this.http.post(url, body);
  }

  isAuthenticated(): boolean {
    const token: string = sessionStorage.getItem('token');
    if (!token) {
      return false;
    }
    return true;
  }

  setSessionToken(data): Promise<boolean> {
    console.log('data', data);
    return new Promise<boolean>((resolve, reject) => {
      const token = 'Bearer' + ' ' + data.token;
      sessionStorage.setItem('plainToken', data.token);
      sessionStorage.setItem('token', token);
      this.getUserLogged().subscribe(res => {
        if (res.success === false) {
          resolve(false);
        } else {
          sessionStorage.setItem('loggedUser', JSON.stringify(res));
          sessionStorage.setItem('client', res.data.client_id);
          localStorage.setItem('language', res.data.language);
          this._client.getColor(res.data.client_id).subscribe((response) => {
            localStorage.setItem('config_color', JSON.stringify(response.data));
            // Handle custom client redirect if configured
            console.log("[navigateByUrl]", response.data.config.redirect);
            if (response.data.config.redirect) {
              this.router.navigateByUrl(response.data.config.redirect);
            }
          });
          resolve(true);
        }
      }, err => reject(err));
    });
  }

  getUserLogged(): Observable<any> {
    return this.http.get(environment.baseUrl + '/api/v2/client/user/authenticated', LibraryHelper.getHeaders());
  }

  verifyClient(clientId: number): Observable<any> {
    return this.http.post(environment.baseUrl + '/api/v2/client/verifyclient', { client_id: clientId }, LibraryHelper.getHeaders());
  }

  dismissStorage(): void {
    sessionStorage.clear();
  }

  syncActiveClient(client: string): void {
    console.log('sync', client);
    sessionStorage.setItem('client', client);
  }

  getActiveClient(): any {
    return +sessionStorage.getItem('client');
  }

  complement(): Observable<any> {
    return this.http.get(environment.baseUrl + '/api/v2/admin/user/form', LibraryHelper.getHeaders());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts